var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.99825C0 4.47639 4.47639 0 9.99826 0C15.5201 0 19.9965 4.47639 19.9965 9.99825C19.9965 15.5201 15.5201 19.9965 9.99826 19.9965C4.47639 19.9965 0 15.5201 0 9.99825ZM9.99826 1.62134C5.37183 1.62134 1.62134 5.37183 1.62134 9.99825C1.62134 14.6247 5.37183 18.3752 9.99826 18.3752C14.6247 18.3752 18.3752 14.6247 18.3752 9.99825C18.3752 5.37183 14.6247 1.62134 9.99826 1.62134Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36759 5.82729C7.29585 4.89909 8.58051 4.32355 9.99805 4.32355C11.4156 4.32355 12.7002 4.89908 13.6285 5.82731C13.9451 6.14389 13.9451 6.65718 13.6285 6.97377C13.3119 7.29035 12.7986 7.29035 12.482 6.97377C11.8454 6.33718 10.9683 5.94489 9.99805 5.94489C9.02778 5.94489 8.15066 6.33718 7.51401 6.97379C7.19741 7.29036 6.68412 7.29034 6.36755 6.97375C6.05097 6.65715 6.05099 6.14386 6.36759 5.82729Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0302 16.0302C16.3468 15.7136 16.86 15.7136 17.1766 16.0302L21.7625 20.6161C22.0791 20.9327 22.0791 21.4459 21.7625 21.7625C21.4459 22.0791 20.9326 22.0791 20.616 21.7625L16.0302 17.1767C15.7136 16.8601 15.7136 16.3468 16.0302 16.0302Z",
    fill: "#1B224C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c70d909feeef1fb12bd88f7611be03f4.svg";
export { ForwardRef as ReactComponent };